import { cn } from '@/utils/tailwind';

export const LayoutTemplateContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex h-full w-full flex-col gap-[12px] overflow-y-hidden">{children}</div>;
};

export const LayoutTemplateTitle = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('flex text-gr-900 Title3S18', className)}>{children}</div>;
};

export const LayoutTemplateContent = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn('flex min-h-0 flex-1 flex-col space-y-2 overflow-y-auto', className)}>
      {children}
    </div>
  );
};

export const LayoutTemplateController = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn('flex gap-3', className)}>{children}</div>;
};
